// Export things like public API, and interfaces from here.
export * from './src/contact-info-card.module';
